import React, { useEffect } from "react";
import { AutocompleteInput, ReferenceInput, required } from "react-admin";
import { useField } from "react-final-form";

interface ISubcontractorInput {
  record: any;
}

const SubcontractorInput = ({ record }: ISubcontractorInput) => {
  const {
    input: { onChange },
  } = useField("route.assignedSubcontractor.subcontractorId");

  useEffect(() => {
    if (record) {
      if (record.subcontractorId) {
        onChange(record.subcontractorId);
      }
    }
  }, [record]);

  return (
    <ReferenceInput
      source="route.assignedSubcontractor.subcontractorId"
      label="Subcontractor"
      reference="subcontractors"
      filter={{ Status: "active" }}
      filterToQuery={(searchText) => {
        if (searchText !== "") return { search: searchText };
      }}
      validate={required()}
    >
      <AutocompleteInput
        optionText={(choice: any) =>
          `${choice?.name} (${choice?.subcontractorIdentifier ?? "N/A"})`
        }
      />
    </ReferenceInput>
  );
};

export default SubcontractorInput;
